import { Routes, Route, Navigate } from "react-router-dom";
import Shell from "@/layout/Shell";
import { CamProvider, useCam } from "@/components/cam/ctx";
import CamNav from "@/components/cam/CamNav";
import { Boxes, Loader2 } from "lucide-react";
import Inventory from "@/pages/cam/Inventory";
import Dashboard from "@/pages/cam/Dashboard";
import Vendors from "@/pages/cam/Vendors";
import Amc from "@/pages/cam/Amc";
import LabView from "@/pages/cam/LabView";
import Scanner from "@/pages/cam/Scanner";
import Maintenance from "@/pages/cam/Maintenance";
import Audits from "@/pages/cam/Audits";
import Locations from "@/pages/cam/Locations";
import Categories from "@/pages/cam/Categories";
import Roles from "@/pages/cam/Roles";
import Reports from "@/pages/cam/Reports";

export default function Cam() {
  return (
    <CamProvider>
      <CamInner />
    </CamProvider>
  );
}

function CamInner() {
  const { loading, error, context, can } = useCam();

  return (
    <Shell role="admin" title="Assets" subtitle="Campus Asset Management — inventory, maintenance & audits.">
      {loading ? (
        <div className="grid place-items-center py-24 text-muted-foreground">
          <Loader2 className="h-6 w-6 animate-spin" /><p className="mt-3 text-sm">Loading asset module…</p>
        </div>
      ) : error ? (
        <div className="glass rounded-2xl p-10 text-center">
          <p className="text-sm text-muted-foreground">Couldn't load the asset module. {error.message}</p>
        </div>
      ) : !context?.configured && !can.admin ? (
        <div className="glass rounded-2xl p-12 text-center max-w-md mx-auto">
          <Boxes className="h-9 w-9 mx-auto text-muted-foreground/40" />
          <h3 className="font-display text-lg tracking-tight mt-3">Asset management isn't enabled yet</h3>
          <p className="text-sm text-muted-foreground mt-1.5">Ask your institute admin to set up Campus Asset Management. Once it's live, your assigned assets will appear here.</p>
        </div>
      ) : (
        <div className="space-y-5">
          <CamNav />
          <Routes>
            <Route index element={<Inventory />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="lab" element={<LabView />} />
            <Route path="vendors" element={<Vendors />} />
            <Route path="amc" element={<Amc />} />
            <Route path="scan" element={<Scanner />} />
            <Route path="maintenance" element={<Maintenance />} />
            <Route path="audits" element={<Audits />} />
            <Route path="locations" element={<Locations />} />
            <Route path="categories" element={<Categories />} />
            <Route path="roles" element={<Roles />} />
            <Route path="reports" element={<Reports />} />
            <Route path="*" element={<Navigate to="/cam" replace />} />
          </Routes>
        </div>
      )}
    </Shell>
  );
}
